import { toast } from "react-toastify";
import { deleteItems, updateStateData } from "../Store/actions";
import store from "../Store/store";
import { sendApiRequest } from "./requestConfig";
import * as xlsx from "xlsx";
import { checkTodayDate, checkTodayDateWithFormat, formatDate } from "./utils";
import { checkUserDetailsFromCookie } from "./userManagement";

// sort listing check response data 
export const sortListingProductsData = (sortBy, sortOrder, reduxKeyToSortValues = "listing_check_response_data", reduxKeyToSaveSortedValue = "sorted_product_list_data") => {
    const userStateDetails = store.getState().userSelections;
    const listingCheckData = typeof userStateDetails[reduxKeyToSortValues] !== "undefined" &&
        typeof userStateDetails[reduxKeyToSortValues].productList !== "undefined" &&
        userStateDetails[reduxKeyToSortValues].productList.length > 0 ?
        userStateDetails[reduxKeyToSortValues].productList : [];

    const sortedList = listingCheckData.length > 0
        ? listingCheckData.slice().sort((a, b) => {
            if (sortBy === "gtin") {
                return sortOrder === "asc"
                    ? parseInt(a.gtin) - parseInt(b.gtin)
                    : parseInt(b.gtin) - parseInt(a.gtin);
            } else if (sortBy === "product_name") {
                return sortOrder === "asc" ? a.description.localeCompare(b.description) : b.description.localeCompare(a.description);
            }
            else if (sortBy === "article_description") {
                return sortOrder === "asc" ? a.article_description.localeCompare(b.article_description) : b.article_description.localeCompare(a.article_description);
            }
            else if (sortBy === "store_count") {
                return sortOrder === "asc"
                    ? parseInt(a.storeCount) - parseInt(b.storeCount)
                    : parseInt(b.storeCount) - parseInt(a.storeCount);
            }
        })
        : [];

    store.dispatch(updateStateData({
        [reduxKeyToSaveSortedValue]: sortedList,
    }));
}

export const checkListings = async () => {
    const currentState = store.getState();
    // GTINs selected for listing check
    const listingCheckGtins = typeof currentState.userSelections.listing_check_selected_gtin !== "undefined" ? currentState.userSelections.listing_check_selected_gtin : [];
    // period value for GTIN listing check
    const listingCheckPeriod = typeof currentState.userSelections.listing_check_period !== "undefined" ? currentState.userSelections.listing_check_period : "";

    // endpoint to send the request to
    const endpointUrl = "listingCheck/lists";
    const listingRequestPayload = {
        gtins: listingCheckGtins,
        week_amount: listingCheckPeriod,
    };
    // send the request
    const sendRequest = await sendApiRequest(endpointUrl, listingRequestPayload, "POST");
    if (typeof sendRequest.success !== "undefined" && sendRequest.success === true) {
        // console.log("Listing check response:", sendRequest);

        let listingCheckGenerated = false;
        if ((typeof sendRequest.response.anyGtinCount !== "undefined" && sendRequest.response.anyGtinCount > 0) || (typeof sendRequest.response.allGtinCount !== "undefined" && sendRequest.response.allGtinCount > 0)) {
            listingCheckGenerated = true;
        }
        // update the store with listing check response data
        store.dispatch(updateStateData({
            listing_check_response_data: sendRequest.response,
            listing_check_generated: listingCheckGenerated,
        }));
        // sort the listing products data by default measure
        sortListingProductsData("gtin", "asc");

    } else {
        toast("Sorry, something went wrong", { type: "error" });
    }
};

export const sortListingStoresData = (sortBy, sortOrder) => {
    const userStateDetails = store.getState().userSelections;
    const listingCheckStoresData = typeof userStateDetails.listing_check_stores !== "undefined" &&
        userStateDetails.listing_check_stores.length > 0 ?
        userStateDetails.listing_check_stores : [];
    const sortedList = listingCheckStoresData.length > 0
        ? listingCheckStoresData.slice().sort((a, b) => {
            if (sortBy === "store_name") {
                return sortOrder === "asc" ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name);
            } else if (sortBy === "street") {
                return sortOrder === "asc" ? a.address.localeCompare(b.address) : b.address.localeCompare(a.address);
            } else if (sortBy === "zip") {
                return sortOrder === "asc" ? a.zipCode.localeCompare(b.zipCode) : b.zipCode.localeCompare(a.zipCode);
            } else if (sortBy === "city") {
                return sortOrder === "asc" ? a.city.localeCompare(b.city) : b.city.localeCompare(a.city);
            } else if (sortBy === "region") {
                return sortOrder === "asc" ? a.region.name.localeCompare(b.region.name) : b.region.name.localeCompare(a.region.name);
            } else if (sortBy === "owner") {
                return sortOrder === "asc" ? a.company.name.localeCompare(b.company.name) : b.company.name.localeCompare(a.company.name);
            }
        })
        : [];
    store.dispatch(updateStateData({
        sorted_listing_check_stores_data: sortedList,
    }));
};

export const fetchListingCheckStores = async (storeIds) => {
    // endpoint to send the request to
    const endpointUrl = "listingCheck/stores";
    const listingStoresPayload = {
        storeIds: storeIds,
    };
    // send the request
    const sendRequest = await sendApiRequest(endpointUrl, listingStoresPayload, "POST");
    if (typeof sendRequest.success !== "undefined" && sendRequest.success === true) {
        // update the store with listing check response data
        store.dispatch(updateStateData({
            listing_check_stores: sendRequest.response,
        }));
        // sort the listing stores data by default measure
        sortListingStoresData("store_name", "asc");
    } else {
        toast("Sorry, something went wrong", { type: "error" });
    }
};

// export const testDelay = async () => {
//     const currentState = store.getState();

//     // endpoint to send the request to
//     const endpointUrl = "delayed-success";

//     // send the request
//     const sendRequest = await sendApiRequest(endpointUrl, {}, "GET");
//     if (typeof sendRequest.success !== "undefined" && sendRequest.success === true) {

//     } else {
//         toast("Sorry, something went wrong", { type: "error" });
//     }
// };

export const fetchListingCheckWithStoresInfo = async (campaignName, usedFor) => {
    const currentState = store.getState();
    // GTINs selected for listing check
    const listingCheckGtins = typeof currentState.userSelections.checked_gtin_values !== "undefined" ? currentState.userSelections.checked_gtin_values : [];
    // period value for GTIN listing check
    const listingCheckPeriod = typeof currentState.userSelections.checked_period_value !== "undefined" ? currentState.userSelections.checked_period_value : "";

    let weekAmountForExcel = listingCheckPeriod;

    // endpoint to send the request to
    const endpointUrl = "listingCheck/listsAndStores";
    let listingRequestPayload = {
        gtins: listingCheckGtins,
        week_amount: listingCheckPeriod,
    };
    // payload for saved listing check
    if (usedFor === "savedListingCheck") {
        listingRequestPayload = {
            gtins: typeof currentState.userSelections.saved_listing_selected_gtins !== "undefined" ? currentState.userSelections.saved_listing_selected_gtins : [],
            week_amount: typeof currentState.userSelections.saved_listing_week_period !== "undefined" ? currentState.userSelections.saved_listing_week_period : "",
        };
        weekAmountForExcel = typeof currentState.userSelections.saved_listing_week_period !== "undefined" ? currentState.userSelections.saved_listing_week_period : "";
    }

    // send the request
    const sendRequest = await sendApiRequest(endpointUrl, listingRequestPayload, "POST");
    if (typeof sendRequest.success !== "undefined" && sendRequest.success === true) {
        // update the store with listing check response data
        // store.dispatch(updateStateData({
        //     listing_check_data_with_stores: sendRequest.response,
        // }));
        // export the listing check data to excel
        exportListingCheckExcel(sendRequest.response, weekAmountForExcel, campaignName);
    } else {
        toast("Sorry, something went wrong", { type: "error" });
    }
};

export const exportListingCheckExcel = (apiResponse, weeks, campaignName) => {
    const checkUserDetails = checkUserDetailsFromCookie();
    const ownerAllowedUserTypes = ["cyreen", "branch"];
    // create a new workbook
    const wb = xlsx.utils.book_new();
    const exportDate = checkTodayDate();//new Date().toLocaleDateString()

    // sort products by GTIN
    const sortedProducts = [...apiResponse.productList].sort(
        (a, b) => a.gtin - b.gtin
    );
    // array of all GTINs
    const allGtins = sortedProducts.map(product => product.gtin.toString());

    const buildMetaRows = ({ gtins, availabilityText }) => {
        let rows = [
            ["Listing Check Results"],
            [`Confidential: The data shown in this dashboard and in related exports is highly sensitive and intended for internal use only. It must not be shared with external partners or third parties without prior permission by Cyreen.`],
            [],
            [`(Table contains all stores where the GTIN(s) listed in this sheet were sold in the past ${weeks} week(s))`],
            [],
            ["Date:", exportDate],
            ["Timeframe:", `Past ${weeks} week(s)`],
        ];

        if (campaignName) {
            rows.push(["Campaign:", campaignName]);
        }

        rows.push(
            ["GTIN:", gtins.join(", ")],
            ["Availability:", availabilityText],
            [],
        );

        return rows;
    };

    const buildTableRows = (stores) => {
        const header = [
            "#",
            "Store Name",
            "Street & No.",
            "ZIP Code",
            "City",
            "Region",
            ...(ownerAllowedUserTypes.includes(checkUserDetails.user_detail.user_type) ? ["Owner"] : [])
        ];

        const rows = stores
            .filter(Boolean)
            .map((store, index) => [
                index + 1,
                store.name,
                store.address,
                store.zipCode,
                store.city,
                store.region?.name ?? "",
                ...(ownerAllowedUserTypes.includes(checkUserDetails.user_detail.user_type) ? [store.company?.name ?? ""] : [])
            ]);

        return [header, ...rows];
    };

    /* ---------- All_GTINs sheet ---------- */
    const allGtinStoreCount = apiResponse.allGtinCount;

    // Converts an array of arrays of JS data to a worksheet.
    const allSheet = xlsx.utils.aoa_to_sheet([
        ...buildMetaRows({
            gtins: allGtins,
            availabilityText: `${allGtinStoreCount} of ${apiResponse.checkedStoresCount} Stores`
        }),
        ...buildTableRows(apiResponse.allGtinList)
    ]);

    xlsx.utils.book_append_sheet(wb, allSheet, "All_GTINs");

    // ------------- any GTIN sheets ------------- //
    const anyGtinStoreCount = apiResponse.anyGtinCount;

    // Converts an array of arrays of JS data to a worksheet.
    const anySheet = xlsx.utils.aoa_to_sheet([
        ...buildMetaRows({
            gtins: allGtins,
            availabilityText: `${anyGtinStoreCount} of ${apiResponse.checkedStoresCount} Stores`
        }),
        ...buildTableRows(apiResponse.anyGtinList)
    ]);

    xlsx.utils.book_append_sheet(wb, anySheet, "Any_GTIN");

    /* ---------- Per-GTIN sheets ---------- */
    sortedProducts.forEach(product => {
        /**
         * Filters out falsy values from the product's stores array.
         * Removes any null, undefined, false, 0, empty string, or NaN entries.
         * @type {Array}
         */
        const productStores = product.stores !== null ? product.stores : []
        const stores = productStores.filter(Boolean);

        const sheet = xlsx.utils.aoa_to_sheet([
            ...buildMetaRows({
                gtins: [product.gtin.toString()],
                availabilityText: `${product.storeCount === null ? 0 : product.storeCount} of ${apiResponse.checkedStoresCount} Stores`
            }),
            ...buildTableRows(stores)
        ]);

        xlsx.utils.book_append_sheet(
            wb,
            sheet,
            product.gtin.toString()
        );
    });

    /* ---------- Download ---------- */
    let fileName = checkTodayDateWithFormat("YYYYMMDD") + "_Listing_Check.xlsx";
    if (campaignName) {
        fileName = checkTodayDateWithFormat("YYYYMMDD") + `_Listing_Check` + `_${campaignName.replaceAll(" ", "_")}.xlsx`;
    }
    xlsx.writeFile(wb, fileName);
};

export const resetListingCheckData = () => {
    store.dispatch(deleteItems(
        [
            "listing_check_selected_gtin",
            "listing_check_period",
            "listing_check_response_data",
            "sorted_product_list_data",
            "listing_check_stores",
            "sorted_listing_check_stores_data",
            "show_loading_cancel_button",
            "checked_period_value",
            "checked_gtin_values",
            "listing_check_saved_data",
            "sorted_saved_product_list_data",
            "saved_listing_selected_gtins",
            "saved_listing_week_period",
            "listing_check_generated",
            "listing_check_saved_stores",
            "listing_check_saved_for_campaign",
            "listing_check_save_option"
        ]
    ));
}

export const saveListingCheckResults = async (campaignId) => {
    const currentState = store.getState();
    // GTINs selected for listing check
    const listingCheckGtins = typeof currentState.userSelections.listing_check_selected_gtin !== "undefined" ? currentState.userSelections.listing_check_selected_gtin : [];
    // period value for GTIN listing check
    const listingCheckPeriod = typeof currentState.userSelections.listing_check_period !== "undefined" ? currentState.userSelections.listing_check_period : "";
    // selected save option (all gtin or any gtin)
    const listingSaveOption = typeof currentState.userSelections.listing_check_save_option !== "undefined" ? currentState.userSelections.listing_check_save_option : "AllGtins";
    // store ids based on selected save option
    const listingCheckResponseData = typeof currentState.userSelections.listing_check_response_data !== "undefined" ? currentState.userSelections.listing_check_response_data : {};

    // endpoint to send the request to
    const endpointUrl = "listingCheck/save/" + campaignId;
    const listingRequestPayload = {
        listing_check_result: {
            gtins: listingCheckGtins,
            week_amount: listingCheckPeriod,
            type: listingSaveOption,
            stores: listingSaveOption === "AllGtins" ? listingCheckResponseData.allGtinList : listingCheckResponseData.anyGtinList,
        }
    };
    // send the request
    const sendRequest = await sendApiRequest(endpointUrl, listingRequestPayload, "POST");

    if (typeof sendRequest.success !== "undefined" && sendRequest.success === true) {
        resetListingCheckData();
        toast("Listing Check saved for campaign", { type: "success" });
        // refresh the saved listing check data
        fetchSavedListingCheckData(campaignId);
        // update the store with listing check response data
        store.dispatch(updateStateData({
            listing_check_generated: false,
        }));
    } else {
        toast("Sorry, something went wrong", { type: "error" });
    }
}

export const fetchSavedListing = async (selectedGtins, weekPeriod, saved_on, saved_type) => {
    // GTINs selected for listing check
    const listingCheckGtins = selectedGtins;
    // period value for GTIN listing check
    const listingCheckPeriod = weekPeriod;

    // endpoint to send the request to
    const endpointUrl = "listingCheck/lists";
    const listingRequestPayload = {
        gtins: listingCheckGtins,
        week_amount: listingCheckPeriod,
    };
    // send the request
    const sendRequest = await sendApiRequest(endpointUrl, listingRequestPayload, "POST");
    if (typeof sendRequest.success !== "undefined" && sendRequest.success === true) {
        // update the store with listing check response data
        const savedDate = typeof saved_on !== "undefined" && saved_on !== null && saved_on !== "" ? formatDate(saved_on) : "";
        store.dispatch(updateStateData({
            listing_check_saved_data: sendRequest.response,
            saved_listing_selected_gtins: listingCheckGtins,
            saved_listing_week_period: listingCheckPeriod,
            listing_check_saved_on: savedDate,
            listing_check_saved_type: saved_type === "AllGtins" ? "Stores with all GTINs listed" : "Stores with any GTIN listed",
        }));
        // sort the listing products data by default measure
        sortListingProductsData("gtin", "asc", "listing_check_saved_data", "sorted_saved_product_list_data");

    } else {
        toast("Sorry, something went wrong", { type: "error" });
    }
};

export const fetchSavedListingCheckData = async (campaignId) => {
    // endpoint to send the request to
    const endpointUrl = "listingCheck/get/" + campaignId;
    // send the request
    const sendRequest = await sendApiRequest(endpointUrl, {}, "GET");
    if (typeof sendRequest.success !== "undefined" && sendRequest.success === true) {
        // listing check saved gtins and week period (to fetch the data again)
        const responseData = typeof sendRequest.response.listing_check_result !== "undefined" ? sendRequest.response.listing_check_result : sendRequest.response;
        if (typeof responseData === "object" && typeof responseData.gtins !== "undefined" && typeof responseData.week_amount !== "undefined") {
            fetchSavedListing(responseData.gtins, responseData.week_amount, sendRequest.response.saved_on, responseData.type);
        }
    } else {
        toast("Sorry, something went wrong", { type: "error" });
    }
}